import { SingleCustomerProduct } from 'utils/api/models/products/singleCustomerProduct';

export const tryAndBuyProduct = (products: SingleCustomerProduct[]) => {
	if (products) {
		return products.find(({ group }) => group === 'TRY_AND_BUY');
	}
	return undefined;
};
